module.exports = __webpack_public_path__ + "static/media/munch4.35945783.wav";